<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12.8655 14.126C9.8975 14.126 8.3855 12.026 8.3855 9.12797C8.3855 6.18797 9.9255 4.07397 12.8655 4.07397C15.3015 4.07397 16.7995 5.52997 16.9955 7.46198H15.3155C15.1755 6.41197 14.4055 5.58598 12.8655 5.58598C10.8635 5.58598 10.0655 7.15397 10.0655 9.12797C10.0655 11.102 10.8635 12.628 12.8655 12.628C14.5455 12.628 15.3855 11.564 15.4695 10.248H13.1455V8.79198H17.1215V9.72997C17.1215 12.404 15.4695 14.126 12.8655 14.126Z"
    />
    <path
      fill="currentColor"
      d="M3.71765 8.86195L8.18365 13.86V14H6.23765L2.07965 9.33795V14H0.44165V4.19995H2.07965V8.41395L6.09765 4.19995H8.02965V4.33995L3.71765 8.86195Z"
    />
  </svg>
</template>
